import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";

function DialogModel(props) {
  const { open, handleClose, handleAgree, wayPoint } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  console.log(wayPoint);
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={fullScreen}
    >
      {wayPoint?.routePointAvailability == "ASSIGNED" ? (
        <div>
          <DialogTitle id="alert-dialog-title">
            {"Deleting Way Points"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
              style={{ color: "red" }}
            >
              This Rote Point can't delete because {wayPoint?.wayPoint.address}{" "}
              already assigned to a schedule
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} autoFocus>
              Skip
            </Button>
          </DialogActions>
        </div>
      ) : (
        <div>
          <DialogTitle id="alert-dialog-title">
            {"Deleting Way Points"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Deletion Need Admin Approval, Are You Sure you Need To Delete{" "}
              {wayPoint?.wayPoint.address}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleAgree}>Yes</Button>
            <Button onClick={handleClose} autoFocus>
              No
            </Button>
          </DialogActions>
        </div>
      )}
    </Dialog>
  );
}

export default DialogModel;
